<template>
  <section class="components-forum-categories-forum">
    <div class="container py-5" v-if="loading">
      <div class="pt-lg-5">
        <h3 class="text-center text-uppercase pb-2 pb-lg-0">
          Quais são seus temas de interesse?
        </h3>
        <p class="text-center">
          Escolha abaixo 3 categorias para começar. Nos iremos selecionar
          conteúdo para você.
        </p>
        <div class="d-flex pt-lg-5 flex-wrap justify-content-center">
          <div
            class="d-flex flex-column align-items-center my-3 btn-category"
            v-for="(category, i) in categories"
            :key="'c' + i"
          >
            <category-item
              :url="category.image"
              :alt="category.description"
              :title="category.title"
              :selected="Boolean(selected.find(id => id == category.id))"
              @select-item="onSelect(category.id)"
            />
            <p class="pt-2">{{ category.title }}</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center my-lg-5">
        <div class="col-10 col-lg-5">
          <button
            class="btn btn-success btn-block text-uppercase"
            @click="sendCategories"
          >
            <h6 class="my-1">
              Escolher Categorias
            </h6>
          </button>
          <button @click="clearCategories" class="btn btn-block pular">
            Pular
          </button>
        </div>
      </div>
    </div>
    <main class="flex-fill pt-5 mt-5" v-else>
      <div class="position-relative slot-wrapper">
        <div class="text-center">
          <b-spinner variant="danger" style="width: 3rem; height: 3rem;" />
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapState } from "vuex";
import CategoryItem from "./CategoryItem.vue";

export default {
  name: "CategoriesForum",
  components: { CategoryItem },
  computed: {
    ...mapState("forum", ["categories"])
  },
  mounted() {
    this.$store
      .dispatch("forum/getCategories")
      .then()
      .finally(() => {
        this.loading = true;
      });
  },
  data() {
    return {
      selected: [],
      loading: false
    };
  },
  methods: {
    onSelect(id) {
      const limitCategories = 3;
      if (this.selected.length == limitCategories) {
        if (this.selected.find(c => c == id)) {
          this.selected = this.selected.filter(c => c != id);
        } else {
          this.selected.pop();
          this.selected = [...this.selected, id];
        }
      } else if (this.selected.find(c => c == id)) {
        this.selected = this.selected.filter(c => c != id);
      } else {
        this.selected = [...this.selected, id];
      }
    },
    sendCategories() {
      if (this.selected.length != 3) {
        this.$message.warning("Escolha 3 Categorias");
        return;
      }
      this.$store
        .dispatch("forum/setCategories", {
          Category1: this.selected[0],
          Category2: this.selected[1],
          Category3: this.selected[2]
        })
        .then()
        .finally(() => {
          this.$store.dispatch("forum/getTopics").then();
          this.$router.push({ name: "forum-feed" });
        });
    },
    clearCategories() {
      this.$store
        .dispatch("forum/setCategories", {
          Category1: null,
          Category2: null,
          Category3: null
        })
        .then();
      this.$store.dispatch("forum/getTopics").then();

      this.$router.push({ name: "forum-feed" });
    }
  }
};
</script>

<style lang="scss">
.components-forum-categories-forum {
  min-height: 80vh;

  .container {
    max-width: 900px;
  }

  .selected {
    background-color: #2db563;
    border-radius: 50%;
  }

  .btn-category {
    max-width: 150px;
  }

  .pular {
    color: #d7d7d7;
    font-weight: 400;
    transition: 0.4s;

    &:hover {
      filter: brightness(70%);
    }
  }

  .slot-wrapper {
    transition: 0.3s padding ease;
  }
}
</style>
